import { useLocation } from "react-router-dom";
import "./header.scss";

export default function Header() {
  const location = useLocation();
  let title =
    location.pathname === "/"
      ? "الرئيسية"
      : location.pathname === "/reports"
      ? "عمليات الإبلاغ"
      : "عمليات البحث";

  return (
    <header className="header">
      <div className="left">
        <div className="info">
          <img src="/assets/avatar.png" alt="avatar" />
          <p>أحمد طه</p>
        </div>
      </div>

      <p className="title">{title}</p>
    </header>
  );
}
